/* eslint-disable @typescript-eslint/no-unused-vars */
"use client";
import { Control, UseFormClearErrors } from "react-hook-form";
import SelectInput from "../../../components/Select";
import formatDate from "../../../utilities/helper";
import Input from "../../../components/Input";
import { useFetchDriversAllData, useFetchDriversAllDataForPickupMerchant } from "../../../apis/driverApis";
import { useFetchAllVehicle } from "../../../apis/pickupApis";
import Section from "../../../components/common/Section";
import NewinputField from "../../../components/NewInput";
import NewSelectInput from "../../../components/NewSelectInput";

const InfoRow = ({
  label,
  value,
  className,
}: {
  label: string;
  value: string;
  className?: string;
}) => (
  <div className={`flex items-center gap-2 w-full ${className}`}>
    <h2 className=" capitalize text-[#212121] text-base font-normal">
      {label} :
    </h2>
    <p className=" text-[#1E293B] text-sm text-end">{value}</p>
  </div>
);
type Props = {
  register: any;
  setValue: any;
  watch: any;
  errors: any;
  clearErrors?: UseFormClearErrors<any>;
  control: Control<any>; // ✅ Add this
  reset?: any; // ✅ Add this
  pickupItem?: any;
};
const AssignDriver = ({
  register,
  errors,
  setValue,
  watch,
  control,
  reset,
  clearErrors,
  pickupItem,
}: Props) => {
    console.log(pickupItem,'pickup')
  // const { data: driverData } = useFetchDriversAllData("");
  const { data: driverData } = useFetchDriversAllDataForPickupMerchant(pickupItem?.clientId)
  const { data: vehicleData, refetch: vehicleRefetch } = useFetchAllVehicle();
  const vehicleListData = vehicleData ?? [];
  const driverListData = driverData ?? [];
  return (
    <div className="w-full py-4 px-6 space-y-4 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-tr-[30px]  ">
      <div className="overflow-y-auto space-y-4">
        <Section
          className="col-span-6"
          mainClassName="grid grid-cols-6 gap-4 border-[1.5px] border-[#D2D2D2] p-2 rounded-lg"
          title="Pickup Information"
        >
          <InfoRow
            className="col-span-2"
            label="Pickup Id"
            value={pickupItem?.pickupId}
          />
          <InfoRow className="col-span-2" label="Vehicle Type" value="Van" />
          <InfoRow
            className="col-span-2"
            label="Order Reference"
            value="#PRQ00123"
          />
          <InfoRow
            className="col-span-3"
            label="Scheduled Date"
            value={`${formatDate(pickupItem?.pickupDate)}`}
          />
          <InfoRow
            className="col-span-3"
            label="Scheduled Time"
            value={`${pickupItem?.timeSlot}`}
          />
          <InfoRow
            className="col-span-6"
            label="Pickup Location"
            value={pickupItem?.fullAddress}
          />
        </Section>

        {/* <SelectInput
          label="Vehicle"
          name="vehicleId"
          selectOptions={vehicleListData?.map((vehicle: any) => ({
            id: vehicle?.id,
            value: vehicle?.id,
            text: vehicle?.name,
          }))}
          placeholder="Select Vehicle"
          register={register}
          clearErrors={clearErrors}
          validation={{ required: "Vehicle is required" }}
          error={errors.vehicleId}
          // disabled={!logisticVehicleTypes.length}
          value={watch("vehicleId")}
          setValue={(value: any) => {
            setValue("vehicleId", value);
          }}
        /> */}
        <div className="grid grid-cols-2 gap-4">
          <NewSelectInput
            label="Select Driver"
            name="driverId"
            placeholder="Select Driver"
            register={register}
            selectOptions={driverListData?.map((driver: any) => ({
              id: driver?.id,
              value: driver?.id,
              text: driver?.name,
            }))}
            clearErrors={clearErrors}
            validation={{ required: "Driver is required" }}
            error={errors.driverId}
            disabled={!driverListData.length}
            value={watch("driverId")}
            setValue={(value: any) => {
              setValue("driverId", value);
            }}
          />
          <NewinputField
            type="number"
            name="driverContact"
            title="Contact"
            placeholder="Enter Driver Contact"
            register={register}
            error={errors.driverContact}
            validation={{ required: "Driver Contact is required" }}
          />
        </div>
      </div>
    </div>
  );
};

export default AssignDriver;
